// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__vCwpf","heading":"style_heading__3f5qe","title":"style_title__2yA3b","body":"style_body__2Av2j"};